import React from 'react';

const AIColorMagicLoader = ({ colorName }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6">
      {/* Main Container */}
      <div className="relative w-32 h-32 mb-8">
        
        {/* Magical Pulsing AI Brain */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <div className="relative">
            {/* Brain Core with Rainbow Gradient */}
            <div className="w-24 h-24 bg-gradient-to-br from-purple-500 via-pink-500 via-rose-500 to-yellow-400 rounded-full animate-pulse shadow-2xl">
              <div className="absolute inset-1 bg-gradient-to-br from-purple-400 via-pink-400 via-rose-400 to-yellow-300 rounded-full animate-ping opacity-75"></div>
              <div className="absolute inset-3 bg-gradient-to-br from-purple-300 via-pink-300 via-rose-300 to-yellow-200 rounded-full animate-bounce"></div>
              {/* Robot Icon with Bounce */}
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-4xl animate-bounce" style={{animationDuration: '1s'}}>🤖</span>
              </div>
            </div>
            
            {/* Multiple Pulse Rings with Different Colors */}
            <div className="absolute inset-0 rounded-full border-4 border-purple-300 animate-ping opacity-40"></div>
            <div className="absolute -inset-2 rounded-full border-4 border-pink-300 animate-ping opacity-30" style={{animationDelay: '0.3s'}}></div>
            <div className="absolute -inset-4 rounded-full border-4 border-rose-300 animate-ping opacity-20" style={{animationDelay: '0.6s'}}></div>
            <div className="absolute -inset-6 rounded-full border-4 border-yellow-300 animate-ping opacity-10" style={{animationDelay: '0.9s'}}></div>
          </div>
        </div>
      </div>

      {/* Enhanced Animated Text */}
      <div className="text-center space-y-6">
        <h3 className="text-3xl font-serif font-bold bg-gradient-to-r from-purple-600 via-pink-600 via-rose-500 to-yellow-500 bg-clip-text text-transparent animate-pulse">
          🤖 AI is weaving your color magic... ✨
        </h3>
        
        {/* Enhanced Loading Dots with Wedding Icons */}
        <div className="flex justify-center items-center space-x-4 mt-8">
          <div className="text-2xl animate-bounce">💕</div>
          <div className="text-2xl animate-bounce" style={{animationDelay: '0.2s'}}>💍</div>
          <div className="text-2xl animate-bounce" style={{animationDelay: '0.4s'}}>🌸</div>
          <div className="text-2xl animate-bounce" style={{animationDelay: '0.6s'}}>💖</div>
          <div className="text-2xl animate-bounce" style={{animationDelay: '0.8s'}}>💎</div>
          <div className="text-2xl animate-bounce" style={{animationDelay: '1s'}}>✨</div>
        </div>
        
        {/* Magical Status Text */}
        <p className="text-sm text-gray-500 animate-pulse italic">
          ✨ Sprinkling wedding magic into every suggestion ✨
        </p>
      </div>
    </div>
  );
};

export default AIColorMagicLoader;
